import React from "react";
import styled from "styled-components";

const Image = styled.img`
  width: 12rem;
  height: 12rem;

  @media (max-width: 768px) {
    width: 8rem;
    height: 8rem;
  }
`;

const ClientLogo = ({ src }) => {
  return <Image src={src} alt={src} data-testid="client-logo" />;
};

export default ClientLogo;
